import { Translation } from 'app/modules/settings/domain/entity/Translation';
import { TranslationResponse } from 'app/modules/settings/infrastructure/dto/response/TranslationResponse';
import { TranslationRequest } from 'app/modules/settings/infrastructure/dto/request/TranslationRequest';
import { TranslationId } from 'app/modules/settings/domain/valueObject/TranslationId';
import { TranslationLanguage } from 'app/modules/settings/domain/valueObject/TranslationLanguage';
import { TranslationText } from 'app/modules/settings/domain/valueObject/TranslationText';
import { BannerParamMapper } from 'app/modules/settings/infrastructure/repository/api/dataMapper/BannerParamMapper';

export class TranslationMapper {

    public static toDomain(translationResponse: TranslationResponse):Translation {
        const fixedTextParams = translationResponse.fixed_text_params
            ? translationResponse.fixed_text_params.map((param) => BannerParamMapper.toDomain(param))
            : null;

        return new Translation(
            new TranslationId(translationResponse.id),
            new TranslationLanguage(translationResponse.language),
            new TranslationText(translationResponse.text),
            translationResponse.link ? new URL(translationResponse.link) : null,
            translationResponse.fixed_text || null,
            fixedTextParams,
            translationResponse.resolved_fixed_text || null,
        );

    }

    public static fromDomain(translation: Translation):TranslationRequest {
        const fixedTextParams = translation.fixedTextParams
            ? translation.fixedTextParams.map((param) => BannerParamMapper.fromDomain(param))
            : undefined;

        return {
            id: translation.id.value,
            language: translation.language.value,
            text: translation.text.value,
            link: translation.link ? translation.link.toString() : null,
            fixedTextParams,
        };

    }

}
